import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { GraduationCap } from 'lucide-react';

export function MasterClassBanner() {
  useLanguage();
  return (
    <div 
      className="relative overflow-hidden rounded-2xl p-6 md:p-8 lg:p-10 text-white shadow-lg"
      style={{ 
        background: 'linear-gradient(90deg, var(--brand-600), var(--brand-400))'
      }}
    >
      {/* Elementos decorativos */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-32 -mt-32" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-purple-500/20 rounded-full blur-2xl -ml-24 -mb-24" />
      
      <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 lg:gap-8">
        {/* Esquerda: Título + Subtítulo */}
        <div className="flex-1 space-y-2 lg:space-y-3">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
            {translateInterfaceText("Master Class Host VSL")}</h1>
          <p className="text-sm sm:text-base lg:text-lg text-white/90 font-normal leading-relaxed max-w-2xl">
            {translateInterfaceText("Aulas exclusivas para aumente suas conversões imediatamente.")}</p>
        </div>
        
        {/* Direita: Botão */}
        <div className="flex gap-3 w-full sm:w-auto">
          <Button 
            size="lg"
            className="bg-white text-blue-700 hover:bg-blue-50 font-semibold shadow-lg hover:shadow-xl transition-all w-full sm:w-auto justify-center"
            onClick={() => document.getElementById('modulos')?.scrollIntoView({ behavior: 'smooth' })}
          >
            <GraduationCap className="w-5 h-5 mr-2" />
            {translateInterfaceText("Ver Módulos")}</Button>
        </div>
      </div>
    </div>
  );
}
